import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { useState, useEffect } from 'react'
import { unwrapResult } from '@reduxjs/toolkit'
import { toast } from '@sales-center/components'
import { getUser } from '../api'
import { IGetUser, ITenantUser } from '@user/store/users/typings'

export const useGetUserById = (userId: string, getResourceCount?: boolean) => {
  const dispatch = useAppDispatch()

  const [user, setUser] = useState<ITenantUser>()
  const [status, setStatus] = useState<'idle' | 'pending' | 'success' | 'fail'>(
    'idle',
  )

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      if (userId) {
        setStatus('pending')
        try {
          const input: IGetUser = {
            id: userId,
            getResourceCount: getResourceCount,
          }
          const result: any = await dispatch(getUser(input))

          if (mounted) {
            if (getUser.fulfilled.match(result)) {
              setUser(unwrapResult(result))
              setStatus('success')
            } else {
              setStatus('fail')
              toast.error(result)
            }
          }
        } catch (error) {
          setUser(undefined)
          if (mounted) {
            setStatus('fail')
          }
        } finally {
          setStatus('idle')
        }
      } else {
        setUser(undefined)
      }
    }
    execute()

    return () => {
      mounted = false
    }
  }, [dispatch, userId, getResourceCount])

  return { status, user }
}
